import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import RichTextEditorBoxDemo from './RichTextEditorDemo';

const BasicInputs = () => (
	<React.Fragment>
		<ContentHeader id="richtTextEditor" title="Rich Text Editor Input" description="Rich text editor controls">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<RichTextEditorBoxDemo />
				</Col>
				<Col md={6}>
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default BasicInputs;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Others/index.js